import React from 'react';
import {assetPath, getOrdinalCode} from '../../utils/web-helper';
import i18n from "../../utils/i18n";

//images
import WeeklyScheduleCharacter from '~images/weekly-schedule/weekly-charac.svg';

const WeeklyScheduleHeader = ({activeStudent}) => {
  const grade = activeStudent && activeStudent.grade_code || 'pk'
  const ordinalCode = getOrdinalCode(grade) || 'Pre-K';

  return (
    <div className="weekly-schedule-header">
      <p>
        <img src={assetPath(WeeklyScheduleCharacter)} />
        <span>For optimal learning, a {i18n.t(`grader.${ordinalCode}`)} must {i18n.t('practice')} </span>
        <strong>5 times a week</strong>
      </p>
    </div>
  )
}
export default WeeklyScheduleHeader